<template>
  <div>
    <v-row>
      <v-col>
        <v-text-field
          v-model="verificationCode"
          label="Verification code"
          @keydown.enter.prevent="verifyMfa"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-spacer />
      <v-col class="text-right">
        <v-btn
          color="primary"
          :disabled="!canVerify"
          :loading="verifying"
          @click="verifyMfa"
        >
          Verify code
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { verifyMfa } from '@/utils/mfa'

export default {
  name: 'VerifyMfaEnterCode',
  props: {
    verificationId: { type: String, default: null },
    resolver: { type: Object, required: true }
  },
  emits: ['mfaVerified', 'error'],
  data: function () {
    return {
      verificationCode: null,
      verifying: false
    }
  },
  computed: {
    canVerify() {
      return this.verificationId && this.verificationCode
    }
  },
  methods: {
    async verifyMfa() {
      if (!this.canVerify) {
        return
      }
      try {
        this.verifying = true
        const verificationResult = await verifyMfa({
          resolver: this.resolver,
          verificationId: this.verificationId,
          verificationCode: this.verificationCode
        })
        this.$emit('mfaVerified', verificationResult)
      } catch (error) {
        this.$emit('error', error)
      } finally {
        this.verifying = false
      }
    }
  }
}
</script>
